import { render, staticRenderFns } from "./system-institutions-management.vue?vue&type=template&id=6be57e87&"
import script from "./system-institutions-management.vue?vue&type=script&lang=js&"
export * from "./system-institutions-management.vue?vue&type=script&lang=js&"
import style0 from "./system-institutions-management.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports